<mat-checkbox [ngModel]="tariffSelectionService.getAudio()"
  (change)="tariffSelectionService.setAudio(!tariffSelectionService.getAudio())" class="top-level-checkbox">
  <span class="checkbox-icon-container">
    <mat-icon>audiotrack</mat-icon>
    {{ "components.room-examination.tariff-categories.audio" | translate }}
  </span>
</mat-checkbox>
<mat-checkbox [ngModel]="tariffSelectionService.getRadio()" class="top-level-checkbox"
  (change)="tariffSelectionService.setRadio(!tariffSelectionService.getRadio())">
  <span class="checkbox-icon-container">
    <mat-icon>radio</mat-icon>
    {{ "components.room-examination.tariff-categories.radio" | translate }}
  </span>
</mat-checkbox>
@if (tariffSelectionService.getRadio()) {
<div class="content">
  <app-broadcaster-type-selector [type]="tariffSelectionService.getRadioType()"
    (typeChange)="tariffSelectionService.setRadioType($event)" [station]="tariffSelectionService.getRadioStation()"
    (stationChange)="tariffSelectionService.setRadioStation($event)"
    stationLabel="components.room-examination.tariff-categories.radio-station" stationInputId="radio-station-input" />
</div>
}
<mat-checkbox [ngModel]="tariffSelectionService.getAudioOrRadio()" class="top-level-checkbox" (change)="
    tariffSelectionService.setAudioOrRadio(
      !tariffSelectionService.getAudioOrRadio()
    )
  ">
  <span class="checkbox-icon-container">
    <mat-icon>hearing</mat-icon>
    {{ "components.room-examination.tariff-categories.none" | translate }}
  </span>
</mat-checkbox>
<mat-checkbox [ngModel]="tariffSelectionService.getVideo()" class="top-level-checkbox"
  (change)="tariffSelectionService.setVideo(!tariffSelectionService.getVideo())">
  <span class="checkbox-icon-container">
    <mat-icon>personal_video</mat-icon>
    {{ "components.room-examination.tariff-categories.video" | translate }}
  </span>
</mat-checkbox>
@if (tariffSelectionService.getVideo()) {
<div class="content">
  <mat-form-field style="display: block">
    <mat-label>{{ "components.room-examination.size" | translate }}</mat-label>
    <mat-select #videoSize [ngModel]="tariffSelectionService.getVideoSize()"
      (selectionChange)="tariffSelectionService.setVideoSize(videoSize.value)">
      @for (option of videoSizes; track $index) {
      <mat-option [value]="option">{{
        "enums.videoSize." + option | translate
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
}
<mat-checkbox [ngModel]="tariffSelectionService.getTv()" class="top-level-checkbox"
  (change)="tariffSelectionService.setTv(!tariffSelectionService.getTv())">
  <span class="checkbox-icon-container">
    <mat-icon>live_tv</mat-icon>
    {{ "components.room-examination.tariff-categories.tv" | translate }}
  </span>
</mat-checkbox>
@if (tariffSelectionService.getTv()) {
<div class="content">
  <app-broadcaster-type-selector [type]="tariffSelectionService.getTvType()"
    (typeChange)="tariffSelectionService.setTvType($event)" [station]="tariffSelectionService.getTvStation()"
    (stationChange)="tariffSelectionService.setTvStation($event)"
    stationLabel="components.room-examination.tariff-categories.tv-station" stationInputId="tv-station-input" />
  <mat-form-field style="display: block">
    <mat-label>{{ "components.room-examination.size" | translate }}</mat-label>
    <mat-select #tvSize [ngModel]="tariffSelectionService.getTvSize()"
      (selectionChange)="tariffSelectionService.setTvSize(tvSize.value)">
      @for (option of tvSizes; track $index) {
      <mat-option [value]="option">{{
        "enums.tvSize." + option | translate
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (tariffSelectionService.getTvSize() === "below-65-inches") {
  <div>
    <mat-form-field>
      <mat-label>{{ "components.room-examination.quantity" | translate }}</mat-label>
      <mat-select #tvQuantity [ngModel]="tariffSelectionService.getTvQuantity()"
        (selectionChange)="tariffSelectionService.setTvQuantity(tvQuantity.value)">
        @for (num of tvQuantities; track num) {
        <mat-option [value]="num">{{ num }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  }
</div>
}